<template>
  <div id="page10" class="page-container" :style="{ 'backgroundImage': 'url(\'' + bg_image + '\')' }">

            <div class="box w-516px pull-right">

                <h2 class="m-t-100">Percebe que as pessoas<br>
                   tem <span class="text-green">dificuldade</span> em<br>
                    manter uma <span class="text-green">conversa</span> com <br>
                    você? As pessoas falam de<br> um jeito difícil?</h2>

                <div class="m-t-30">
                  <b-button pill class="w-76 m-t-10 btn-answers" @click="computa(2, $event)">Sempre</b-button>
                  <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(1.5, $event)">Frequentemente</b-button>
                  <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(1, $event)">Às vezes</b-button>
                  <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(0.5, $event)">Raramente</b-button>
                  <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(0, $event)">Nunca</b-button>

                  <div class="w-76 m-t-60">
                    <b-button pill class="m-t-20 pull-left w-35" v-on:click="previous">Voltar</b-button>
                    <b-button pill class="m-t-20 btn-success pull-right w-55 boldit" v-on:click="next">Seguinte</b-button>
                  </div>
                </div>

            </div>
  </div>

</template>

<script>
import { bus } from '../main';
import Email from '../smtp.js'


export default {

  name: "Cadastre",
  data() {
      return {
        form: {
          nome: ''
        },
        show: true,
        answer_selected: false,
        bg_image: require('../../assets/page10-bg.png')
      }
    },
    props:['count'],
    methods: {
      next() {
        if (this.answer_selected == false) {
            alert('Por favor, selecione uma resposta');
            return false;
        }

        /*
        Email.send({
          //b961c596-b66c-4d46-aae5-ae23c57199b6
            SecureToken: "e32e3e8b-4a44-40ca-929d-809706ccf29f",
            //Host : "smtp.phonakbr.com.br",
            //Username : "site@phonakbr.com.br",
            //Password : "da45gdfyUJLK",
            To : document.getElementById('email_to_send').value, //'doug.rodrigues@gmail.com',
            From : "site@phonakbr.com.br",
            Subject : "Cupom de desconto PhonakBr",
            Body : '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><title>Cupom de Desconto</title><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /></head><body bgcolor="#FFFFFF"><table id="Table_01" width="660" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="660" height="226"><img id="email_cupom_de_desconto_01" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_01.jpg" alt="" style="display: block" /></td></tr><tr><td width="660" height="202"><img id="email_cupom_de_desconto_02" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_02.jpg" alt="" style="display: block" /></td></tr><tr><td width="660" height="134"><img id="email_cupom_de_desconto_03" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_03.jpg" alt="" style="display: block" /></td></tr><tr><td width="660" height="268"><img id="email_cupom_de_desconto_04" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_04.jpg" alt="" style="display: block" /></td></tr><tr><td width="660" height="146"><img id="email_cupom_de_desconto_05" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_05.jpg" alt="" style="display: block" /></td></tr><tr><td width="660" height="162"><a href="https://phonakbr.com.br"><img id="email_cupom_de_desconto_06" src="https://www.phonakbr.com.br/teste-auditivo/assets/email/email-cupom-de-desconto_06.jpg" alt="" style="display: block" /></a></td></tr></table></body></html>'
        }).then(
          message => alert(message)
        );
        */

        if(document.getElementById('pontuacao').value > 5) {
            this.$router.push('resultado2')
        } else {
            this.$router.push('resultado1')
        }


      },
      computa(peso, $event) {
        var x = document.getElementsByClassName("btn-answers");
        var i;
        for (i = 0; i < x.length; i++) {
          x[i].classList.remove("btn-success");
        }

        //$event.currentTarget.style = 'background-color:#96c303 !important;';
        $event.currentTarget.classList.add("btn-success");
        console.log($event.currentTarget.dataWeight);
        console.log($event.toElement);

        console.log(peso);
        bus.$emit('computaPontuacao', {question:10, answer: peso});
        this.answer_selected = true;
        //$emit('computa-pontuacao')
        //console.log(this.count)
        //this.count = 10
      },
      previous() {
        this.$router.push('page9')
      }
    }
}
</script>

<style scoped>


#page10 #box {

}
</style>
